var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinUpYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1",
    width: "121.1%",
    height: "114.3%",
    x: "-10.5%",
    y: "-7.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "path-2",
    points: "31.5 28.5 23.859 32.517 25.318 24.009 19.136 17.983 27.679 16.741 31.5 9 35.321 16.741 43.864 17.983 37.682 24.009 39.141 32.517"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-3",
    width: "102.8%",
    height: "105.8%",
    x: "-1.4%",
    y: "-3.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    radius: 2,
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Nav-/-PinUp-Activated",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Nav-/-PinUp"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bookmark+favorite+favourite+important+note+ribbon+icon-1320166548120904555_0",
    fill: "#FFF",
    filter: "url(#filter-1)",
    transform: "translate(12.96 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "nonzero",
    d: "M33.8595646,3.10949543e-06 L3.22048323,3.10949543e-06 C1.46825986,-0.00241435631 0.045149901,1.40523116 0.0401438019,3.14564035 L0.0401438019,52.8501595 C0.027887698,54.1224276 0.800027246,55.2728311 1.9871677,55.7507929 C3.17008102,56.2472929 4.53755114,55.9884135 5.45366527,55.094541 L18.1612199,42.6957551 C18.3717788,42.4912231 18.7082691,42.4912231 18.918828,42.6957551 L31.6307873,55.090166 C32.5463251,55.9851309 33.9145029,56.2441443 35.0972848,55.7464179 C36.28119,55.2676586 37.051066,54.1197606 37.0398797,52.8501595 L37.0398797,3.14564035 C37.0348979,1.40523116 35.611788,-0.00241435631 33.8595646,3.10949543e-06 Z M34.6065869,52.8499205 C34.610728,53.0614576 34.4783621,53.2525975 34.2762487,53.3267946 C34.0735976,53.4196917 33.8330976,53.375704 33.678248,53.2174198 L33.678248,53.2174198 L20.7989195,40.8230691 C19.5409707,39.6221549 17.5361614,39.6221549 16.2782127,40.8230691 L3.40334679,53.2174198 C3.2478232,53.3744765 3.00817444,53.4183085 2.80534609,53.3267946 C2.60323275,53.2525975 2.47086679,53.0614576 2.47500794,52.8499205 L2.47500794,3.14564305 C2.4799976,2.85498928 2.72304526,2.6225771 3.0195553,2.625 L34.0620395,2.625 C34.3585496,2.6225771 34.6015972,2.85498928 34.6065869,3.14564305 L34.6065869,52.8499205 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Star"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinejoin: "square",
    strokeWidth: 2,
    d: "M37.8130773,30.6892054 L36.6073868,23.6594906 L41.7147736,18.6810189 L34.6565386,17.6553973 L31.5,11.2595515 L28.3434614,17.6553973 L21.2852264,18.6810189 L26.3926132,23.6594906 L25.1869227,30.6892054 L31.5,27.3702243 L37.8130773,30.6892054 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bookmark+favorite+favourite+important+note+ribbon+icon-1320166548120904555_0",
    fill: "#FFF",
    fillRule: "nonzero",
    transform: "translate(12.96 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M33.8595646,3.10949542e-06 L3.22048323,3.10949542e-06 C1.46825986,-0.00241435631 0.045149901,1.40523116 0.0401438019,3.14564035 L0.0401438019,52.8501595 C0.027887698,54.1224276 0.800027246,55.2728311 1.9871677,55.7507929 C3.17008102,56.2472929 4.53755114,55.9884135 5.45366527,55.094541 L18.1612199,42.6957551 C18.3717788,42.4912231 18.7082691,42.4912231 18.918828,42.6957551 L31.6307873,55.090166 C32.5463251,55.9851309 33.9145029,56.2441443 35.0972848,55.7464179 C36.28119,55.2676586 37.051066,54.1197606 37.0398797,52.8501595 L37.0398797,3.14564035 C37.0348979,1.40523116 35.611788,-0.00241435631 33.8595646,3.10949542e-06 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Star",
    fill: "#EEB200",
    stroke: "#EEB200",
    strokeWidth: 2,
    d: "M37.225292,29.8801884 L36.1318585,23.5049821 L40.7637171,18.9900359 L34.362646,18.0599058 L31.5,12.2595515 L28.637354,18.0599058 L22.2362829,18.9900359 L26.8681415,23.5049821 L25.774708,29.8801884 L31.5,26.8702243 L37.225292,29.8801884 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bookmark+favorite+favourite+important+note+ribbon+icon-1320166548120904555_0",
    fill: "#3C444D",
    fillRule: "nonzero",
    transform: "translate(12.96 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M33.8595646,3.16502214e-06 L3.22048323,3.16502214e-06 C1.46825986,-0.00245746982 0.045149901,1.43032458 0.0401438019,3.2018125 L0.0401438019,53.7939124 C0.027887698,55.0888995 0.800027246,56.259846 1.9871677,56.7463428 C3.17008102,57.2517088 4.53755114,56.9882065 5.45366527,56.0783721 L18.1612199,43.4581793 C18.3717788,43.2499949 18.7082691,43.2499949 18.918828,43.4581793 L31.6307873,56.073919 C32.5463251,56.9848654 33.9145029,57.248504 35.0972848,56.7418897 C36.28119,56.2545811 37.051066,55.0861849 37.0398797,53.7939124 L37.0398797,3.2018125 C37.0348979,1.43032458 35.611788,-0.00245746982 33.8595646,3.16502214e-06 Z M34.6065869,53.7936691 C34.610728,54.0089836 34.4783621,54.2035368 34.2762487,54.2790588 C34.0735976,54.3736148 33.8330976,54.3288416 33.678248,54.1677309 L33.678248,54.1677309 L20.7989195,41.5520525 C19.5409707,40.3296934 17.5361614,40.3296934 16.2782127,41.5520525 L3.40334679,54.1677309 C3.2478232,54.3275922 3.00817444,54.3722069 2.80534609,54.2790588 C2.60323275,54.2035368 2.47086679,54.0089836 2.47500794,53.7936691 L2.47500794,3.20181524 C2.4799976,2.90597123 2.72304526,2.66940884 3.0195553,2.671875 L34.0620395,2.671875 C34.3585496,2.66940884 34.6015972,2.90597123 34.6065869,3.20181524 L34.6065869,53.7936691 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinUpYellow);
export default __webpack_public_path__ + "static/media/PinUpYellow.5993d4de6f735500e99d34b2b637271c.svg";
export { ForwardRef as ReactComponent };